import { render, staticRenderFns } from "./Lateral.vue?vue&type=template&id=1d32b3d6&scoped=true&"
import script from "./Lateral.vue?vue&type=script&lang=js&"
export * from "./Lateral.vue?vue&type=script&lang=js&"
import style0 from "./Lateral.vue?vue&type=style&index=0&id=1d32b3d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32b3d6",
  null
  
)

export default component.exports